import { fromJS, Record } from 'immutable';
import { generateKeys, generateSchema } from '../../utils/helpers/model.helper';

export const REFER_A_FRIEND_LABELS_SCHEMA = Object.freeze({
  TITLE: '',
  OVERVIEW: '',
  CTA_RAF_SCREEN: '',
  INVITE_MESSAGE: '',
  COPY_CTA: '',
});
export const RECORD = generateSchema(REFER_A_FRIEND_LABELS_SCHEMA);
export const KEYS: any = generateKeys(REFER_A_FRIEND_LABELS_SCHEMA);

export class ReferAFriendLabels extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get title(): string {
    return this.get(KEYS.TITLE);
  }

  get overview(): string {
    return this.get(KEYS.OVERVIEW);
  }

  get ctaRafScreen(): string {
    return this.get(KEYS.CTA_RAF_SCREEN);
  }

  get inviteMessage(): string {
    return this.get(KEYS.INVITE_MESSAGE);
  }

  get copyCta(): string {
    return this.get(KEYS.COPY_CTA);
  }
}
